import { render, staticRenderFns } from "./AdminStrainEditModal.vue?vue&type=template&id=06122a2c"
import script from "./AdminStrainEditModal.vue?vue&type=script&lang=js"
export * from "./AdminStrainEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06122a2c')) {
      api.createRecord('06122a2c', component.options)
    } else {
      api.reload('06122a2c', component.options)
    }
    module.hot.accept("./AdminStrainEditModal.vue?vue&type=template&id=06122a2c", function () {
      api.rerender('06122a2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminStrainEditModal.vue"
export default component.exports